import { MousePointer2, Ruler, Type, Paintbrush, Trash2 } from 'lucide-react';
import { Button } from '@/components/ui/button';

export function AnnotationToolbar({ activeTool, onToolChange, disabled }) {
  const renderTool = (id, label, children) => {
    const isActive = activeTool === id;
    return (
      <Button
        key={id}
        variant={isActive ? 'default' : 'ghost'}
        size="icon"
        className={`h-7 w-7 transition-all ${isActive ? 'bg-primary text-primary-foreground shadow-sm' : ''}`}
        onClick={() => onToolChange(id)}
        title={label}
        disabled={disabled}
        data-testid={`cad-tool-${id}`}
      >
        {children}
      </Button>
    );
  };

  return (
    <div className="flex flex-col gap-0.5 p-1 bg-card border border-border rounded-lg shadow-sm">
      {renderTool('select', 'Select', <MousePointer2 className="h-3.5 w-3.5" />)}
      {renderTool('ruler', 'Dimension', <Ruler className="h-3.5 w-3.5" />)}
      {renderTool('text', 'Text', <Type className="h-3.5 w-3.5" />)}
      {renderTool('highlight', 'Highlight', <Paintbrush className="h-3.5 w-3.5" />)}
      {renderTool('delete', 'Delete', <Trash2 className="h-3.5 w-3.5" />)}
    </div>
  );
}
